const { MessageComponent } = require('@benchlabs/message-component');
require('client-web-app/components/message-styles.scss');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.web.messagePreview', deps)
  .directive('blMessagePreview', reactDirective => reactDirective(MessageComponent, ['text']));
